import { inView, animate, stagger } from "motion";

export default function animateStagger(target) {
	return {
		init() {
			const items = this.$root.querySelectorAll(target);
			items.forEach((item) => {
				item.style.opacity = "0";
			});
			inView(this.$root, () => {
				animate(
					target,
					{ opacity: 1 },
					{
						duration: 0.3,
						delay: stagger(0.15),
						easing: "ease-out",
					}
				);
			});
		},
	};
}

// const hasHtmx = document.querySelector(".sprig-component") ?? false;
// if (hasHtmx) {
// 	htmx.on("htmx:afterSwap", function (event) {
// 		inView(".animateIn", (info) => {
// 			animate(
// 				info.target,
// 				{ opacity: [0, 1] },
// 				{
// 					duration: 0.6,
// 					delay: 0.3,
// 					easing: "ease-out",
// 				}
// 			);
// 		});
// 	});
// }
